import { dateWithSlashes, formatDate, formatDateRange } from 'Utils/Dates'
import { guestsAddedToString } from 'Utils/guestHelpers'

const DateRangeAndGuests = ({ reservation }) => {
  const { from, guests, isDayUse, isFlexible, to } = reservation
  const props = { format: dateWithSlashes, inputFormat: 'YYYY-MM-DD' }
  const validTo = isFlexible ? 'TBD' : to
  const datesToShow = isDayUse ? formatDate(from, props) : formatDateRange(from, validTo, props)
  const guestsLabel = guestsAddedToString(guests, guests?.useGuests)

  return (
    <div className="text-muted">
      <span className="mb-1 not-all-block-loading">
        {datesToShow}
      </span>

      {guestsLabel && <p className="mb-1">{guestsLabel}</p>}
    </div>
  )
}

export default DateRangeAndGuests
